import React, { useState } from "react";
import {
  BiLocationPlus,
  BiSolidBuilding,
  BiSolidFlag,
  BiSolidPhoneCall,
  BiSolidUserCircle,
  BiSolidZap,
} from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { PhoneInput } from "react-international-phone";
import toast from "react-hot-toast";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { orderTerms, statesArray } from "../../data";
import {
  generateCustomID,
  getDocByKeyValue,
  saveData,
  uniqueID,
} from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
import { FiShoppingCart, FiUser } from "react-icons/fi";
const AddNewAddress = ({ modal, toggle, setData, gettingCustomers }) => {
  const [loading, setLoading] = useState(false);
  const [billing, setBilling] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    company: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    country: "",
    postcode: "",
    order_return_status: "",
    order_sms: "",
  });
  const resetForm = () => {
    setBilling({
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      company: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      country: "",
      postcode: "",
      order_return_status: "",
      order_sms: "",
      mobile_number: "",
      website: "",
      blind_dropship: false,
    });
  };
  const handleSave = () => {
    setLoading(true);
    if (
      billing?.first_name === "" ||
      billing?.last_name === "" ||
      billing?.phone === "" ||
      billing?.email === "" ||
      billing?.address_1 === "" ||
      billing?.city === "" ||
      billing?.country === "" ||
      billing?.state === "" ||
      billing?.postcode === "" ||
      billing?.terms === ""
    ) {
      toast.error("Please fill all the required fields");
      setLoading(false);
      return;
    }
    getDocByKeyValue("Customers", "email", billing?.email).then((data) => {
      if (data?.length == 0) {
        generateCustomID("Customers", "id").then((res) => {
          if (res) {
            let obj = {
              billing: [billing],
              _id: uniqueID(),
              first_name: billing?.first_name,
              last_name: billing?.last_name,
              email: billing?.email,
              approved: true,
              type: "company",
              id: res,
              createdAt: Date.parse(new Date()),
            };
            saveData("Customers", obj?._id, obj).then((res) => {
              toast.success(`Customer ${obj?.id} Created Successfully`);
              gettingCustomers();
              setLoading(false);
              setData([]);
              setBilling({});
              toggle();
            });
          }
        });
      } else {
        toast.error("Customer already exists with the same email");
        setLoading(false);
      }
    });
  };
  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        size="xl"
        onClosed={resetForm}
      >
        <ModalBody className="p-0 border-0">
          <div className="modern-modal-header  d-flex justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
            <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
              <FiUser className="text-primary" /> Add New Customer
            </h5>
            <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
          </div>

          <Row className="mb-3  p-3 rounded">
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"First Name "}
                placeholder={"First Name"}
                icon={<BiSolidUserCircle size={20} color="#B0B0B0" />}
                value={billing?.first_name}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    first_name: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Last Name "}
                placeholder={"Last Name"}
                icon={<BiSolidUserCircle size={20} color="#B0B0B0" />}
                value={billing.last_name}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    last_name: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <Label className="fw-bold">Phone</Label>
              <PhoneInput
                placeholder="Enter phone number"
                value={billing.phone}
                style={{ width: "100%" }}
                onChange={(e) =>
                  setBilling({
                    ...billing,
                    phone: e,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Email"}
                placeholder={"Email"}
                icon={<BiSolidPhoneCall size={20} color="#B0B0B0" />}
                value={billing.email}
                handleChange={(e) => {
                  let val = e.target.value;
                  setBilling({
                    ...billing,
                    email: val?.trim(),
                  });
                }}
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Company Name"}
                placeholder={"Company name"}
                icon={
                  <BiSolidBuilding size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.company}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    company: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address line1"}
                placeholder={"Enter Billing Address"}
                icon={
                  <BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.address_1}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    address_1: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address line2"}
                placeholder={"Enter Billing Address"}
                icon={
                  <BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.address_2}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    address_2: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Country"}
                placeholder={"Enter Country name"}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.country}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    country: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                dropdown
                type={"select"}
                label={"State"}
                placeholder={"Enter State"}
                className={"border border-1 rounded-3"}
                options={statesArray}
                showSearch={true}
                value={billing?.state}
                handleChange={(value) => {
                  setBilling({
                    ...billing,
                    state: value,
                  });
                }}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"City"}
                placeholder={"Enter City name"}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.city}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    city: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Zip Code"}
                placeholder={"Enter Zip Code"}
                icon={<BiSolidZap size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.postcode}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    postcode: e.target.value,
                  })
                }
              />
            </Col>
            <Row className="mb-1">
              <h5 className="primary-color">Default Settings</h5>
            </Row>
            <Row>
              <Col md={3}>
                <FormInput
                  dropdown
                  type={"select"}
                  label={"Payment Terms *"}
                  placeholder={"Enter State"}
                  className={"border border-1 rounded-3"}
                  options={orderTerms?.map((term) => ({ label: term.label, value: term.value }))}
                  handleChange={(e, value) => {
                    setBilling({
                      ...billing,
                      terms: e,
                    });
                  }}
                  icon={
                    <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
                  }
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2">
              <GeneralButton
                title={"Cancel"}
                className={"bg-white  border-1 text-black"}
                width={"180px"}
                handleClick={() => {
                  toggle();
                  setBilling({});
                }}
              />
              <GeneralButton
                title={"Save"}
                className={"bg-primary-color border-0"}
                width={"180px"}
                handleClick={handleSave}
                loading={loading}
                disabled={loading}
              />
            </div>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default AddNewAddress;
